import React, { MouseEvent } from 'react';
import { useHistory } from 'react-router-dom';

import routesConfig from 'constants/routesConfig.json';
import SmartActionFormButton from 'form/components/SmartActionFormButton';
import { FormPageLocationState } from 'form/types';
import { ReflexStep } from 'shiftNotes/_types';
import { useNoteFormOpen } from 'shiftNotes/components/NotesStack/NoteFormOpenContext';
import { usePosthogCapture } from 'shiftNotes/posthogCapture/shiftNotes';

interface NoteCardPrefillFormProps {
  step: ReflexStep;
  noteId: string;
  reflexId: string;
}

export default function NoteCardPrefillForm({
  step,
  noteId,
  reflexId,
}: NoteCardPrefillFormProps): JSX.Element | null {
  const history = useHistory();
  const shiftNotesCapture = usePosthogCapture();
  const noteFormOpen = useNoteFormOpen();

  if (!step.form_instance) return null;

  const handleOpenForm = () => {
    shiftNotesCapture.noteReflexPrefillFormOpened({
      shift_note_id: noteId,
      reflex_id: reflexId,
      step_id: step.id,
      is_filled: false,
    });
    if (noteFormOpen) {
      noteFormOpen.onOpenForm({
        formInstance: step.form_instance!,
        isCompleted: false,
        origin: 'reflex_prefill',
        noteId,
      });
      return;
    }
    const locationState: FormPageLocationState = {
      formInstance: step.form_instance!,
      isCompleted: false,
      origin: 'reflex_prefill',
    };
    history.push(
      `${routesConfig.SHIFT_NOTES_PAGE}/${noteId}/form`,
      locationState
    );
  };

  return (
    <div
      onClick={(e: MouseEvent) => e.stopPropagation()}
      onKeyDown={(e: React.KeyboardEvent) => e.stopPropagation()}
      role="presentation"
    >
      <SmartActionFormButton
        templateName={step.title}
        isFilled={false}
        onClick={handleOpenForm}
      />
    </div>
  );
}
